import { isNil, get } from 'lodash';
import { defaultOrdering } from '../../lib/dropdowns';
export function getSegmentsPositionsDepartments(props) {
  const industryId = props.staticData.account.industryId;

  const segments = props.staticData.segmentTypes.filter(x =>
    x.industryId === industryId &&
    isNil(x.subElement) &&
    isNil(x.parentId)).sort(defaultOrdering);

  // positions
  const categoryIdPositions = get(props.staticData.skillCategoryTypes.find(x =>
    x.industryId === industryId &&
    x.hardcodelink === 'POSITIONS'), 'id', -1);
  let positions = [];
  if (categoryIdPositions !== -1) {
    positions = props.staticData.skillTypes.filter(x =>
      x.skillCategoryTypeId === categoryIdPositions &&
      x.industryId === industryId).sort(defaultOrdering);
  }

  // departments
  const categoryIdDepartments = get(props.staticData.skillCategoryTypes.find(x =>
    x.industryId === industryId &&
    x.hardcodelink === 'DEPARTMENTS'), 'id', -1);
  let departments = [];
  if (categoryIdDepartments !== -1) {
    departments = props.staticData.skillTypes.filter(x =>
      x.skillCategoryTypeId === categoryIdDepartments &&
      x.industryId === industryId).sort(defaultOrdering);
  }

  return {segments, positions, departments};
}



// WEBPACK FOOTER //
// ./shared/common/staticData/SegmentsPositionsDepartments.js